"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var lite_1 = __importDefault(require("mime/lite"));
var react_1 = __importStar(require("react"));
var Cancel_1 = __importDefault(require("../../../../../../packages/ui-shared-lite/Icons/Cancel"));
var Microphone_1 = __importDefault(require("../../../../../../packages/ui-shared-lite/Icons/Microphone"));
var VoiceRecorder = function (props) {
    var _a;
    var _b = (0, react_1.useState)(false), isRecording = _b[0], setIsRecording = _b[1];
    var mediaRecorder = (0, react_1.useRef)(null);
    var mediaChunks = (0, react_1.useRef)([]);
    var mediaStream = (0, react_1.useRef)(null);
    var isCancelled = (0, react_1.useRef)(false);
    var getMediaStream = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var stream, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, window.navigator.mediaDevices.getUserMedia({ audio: true, video: false })];
                case 1:
                    stream = _b.sent();
                    mediaStream.current = stream;
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _b.sent();
                    console.error('[VoiceRecorder] - Error while creating MediaStream', err_1);
                    (_a = props.onNotAvailable) === null || _a === void 0 ? void 0 : _a.call(props);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    (0, react_1.useEffect)(function () {
        return function () {
            var _a, _b, _c, _d;
            (_a = mediaRecorder.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('dataavailable', onResult);
            props.onStart && ((_b = mediaRecorder.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('start', props.onStart));
            (_c = mediaRecorder.current) === null || _c === void 0 ? void 0 : _c.removeEventListener('stop', onStop);
            (_d = mediaRecorder.current) === null || _d === void 0 ? void 0 : _d.removeEventListener('error', onError);
        };
    }, []);
    var onError = function (ev) {
        var _a;
        console.error("[VoiceRecorder] - Error while recording audio: ".concat(ev.error.name, " (").concat(ev.error.code, ") - ").concat(ev.error.message));
        (_a = props.onNotAvailable) === null || _a === void 0 ? void 0 : _a.call(props);
    };
    var onResult = function (e) {
        if (e.data.size > 0) {
            mediaChunks.current.push(e.data);
        }
    };
    var onStop = function () { return __awaiter(void 0, void 0, void 0, function () {
        var firstBlob, ext, blob, arrayBuffer, buffer, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isCancelled.current) {
                        isCancelled.current = false;
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, 6, 7]);
                    if (!mediaChunks.current.length) return [3 /*break*/, 4];
                    firstBlob = mediaChunks.current[0];
                    ext = lite_1.default.getExtension(firstBlob.type) || 'ogg';
                    blob = new Blob(mediaChunks.current);
                    return [4 /*yield*/, blob.arrayBuffer()];
                case 2:
                    arrayBuffer = _a.sent();
                    buffer = Buffer.from(arrayBuffer);
                    return [4 /*yield*/, props.onDone(buffer, ext)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [3 /*break*/, 7];
                case 5:
                    err_2 = _a.sent();
                    console.error('[VoiceRecorder] - Error converting the audio blob into a buffer', err_2);
                    return [3 /*break*/, 7];
                case 6:
                    setIsRecording(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var stopRecording = function () {
        var _a, _b;
        if (((_a = mediaRecorder.current) === null || _a === void 0 ? void 0 : _a.state) !== 'inactive') {
            (_b = mediaRecorder.current) === null || _b === void 0 ? void 0 : _b.stop();
            mediaStream.current && mediaStream.current.getTracks().forEach(function (track) { return track.stop(); });
            mediaChunks.current = [];
            setIsRecording(false);
        }
    };
    var cancelRecording = function () {
        isCancelled.current = true;
        stopRecording();
    };
    var startRecording = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(!mediaStream.current || mediaStream.current.getTracks().some(function (track) { return track.readyState === 'ended'; }))) return [3 /*break*/, 2];
                    return [4 /*yield*/, getMediaStream()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (mediaStream.current) {
                        mediaRecorder.current = new MediaRecorder(mediaStream.current);
                        mediaRecorder.current.addEventListener('dataavailable', onResult);
                        props.onStart && mediaRecorder.current.addEventListener('start', props.onStart);
                        mediaRecorder.current.addEventListener('stop', onStop);
                        mediaRecorder.current.addEventListener('error', onError);
                        mediaRecorder.current.start();
                        setIsRecording(true);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    if (!window.MediaRecorder) {
        (_a = props.onNotAvailable) === null || _a === void 0 ? void 0 : _a.call(props);
        return null;
    }
    return (react_1.default.createElement("div", { className: 'bpw-voice-recorder' },
        react_1.default.createElement("button", { className: (0, classnames_1.default)('bpw-send-button', props.className), onClick: isRecording ? stopRecording : startRecording },
            react_1.default.createElement(Microphone_1.default, { fill: isRecording ? '#f1f1f1' : 'black' })),
        isRecording && (react_1.default.createElement("button", { className: (0, classnames_1.default)('bpw-send-button', props.className), onClick: cancelRecording },
            react_1.default.createElement(Cancel_1.default, { fill: "#ff0000" })))));
};
exports.default = VoiceRecorder;
